export default __webpack_public_path__ + "static/media/startRecording.dfae8965.svg";